import { render, staticRenderFns } from "./Page5.vue?vue&type=template&id=af706ec6&"
import script from "./Page5.vue?vue&type=script&lang=js&"
export * from "./Page5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports